/* eslint-disable @typescript-eslint/no-explicit-any */
import {Box, Button, Grow, TextField, Grid, Divider} from '@mui/material';
import {Navbar} from '../../../components/common/NavBar/NavBar';
import {
  accTextBox,
  authContainer,
  contentContainer,
  continueBtn,
  createAccContainer,
  descContainer,
  emailAddrBox,
  emailError,
  emailSignUp,
  primaryTitleBox,
  secondTitleBox,
  textFieldSignIn,
} from './LandingViewStyles';
import {ChangeEvent, useEffect, useRef, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {PopUp} from '../../../components/common/PopUp/PopUp';
import {usePopUp} from '../../../hooks/usePopUp';
import {
  app,
  getCurrentUser,
  signInWithEmailAndPassword,
} from '../../../providers/Accounts';
import {digiStaffLogo} from '../../../components/common/Image/Image';

import {checkOnboardingStatus} from '../../../providers/api/profile';
import validator from 'validator';
import PasswordSection from './PasswordSection';

export const LandingView = () => {
  const [formError, setFormError] = useState({email: ''});
  const [showPasswordSection, setShowPasswordSection] = useState(false);
  const [isContinueDisabled, setIsContinueDisabled] = useState(false);

  const emailRef = useRef<HTMLInputElement>();
  const navigate = useNavigate();

  const {handlePopUp, popUp, closePopUp, status, message} = usePopUp();
  const pwTemp = 'tdsa212empPasswrd'; // temp pw for cognito account validation
  const fullyOnboard = 10;

  // Detect user login status
  // If user logged in before, redirect user to job feed
  useEffect(() => {
    const autoLogin = async () => {
      try {
        const userAuthStatus = await getCurrentUser(app);
        const onboardingStatus = await checkOnboardingStatus();
        if (
          userAuthStatus?.code === 'DS_USER_AUTHENTICATED' &&
          onboardingStatus === fullyOnboard
        ) {
          navigate('/jobs');
        }
      } catch (error) {
        return;
      }
    };
    autoLogin().catch(err => {
      console.log(err);
      console.log(err);
    });
  }, [navigate]);

  const validateField = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const value = e.target.value.toLowerCase();
    const result = validator.isEmail(value);

    !result
      ? setFormError({
          ...formError,
          email: 'Please provide a valid email address',
        })
      : setFormError({...formError, email: ''});
  };

  const handleKeyDown = (e: {key: string}) =>
    e.key === 'Enter' &&
    !formError.email &&
    !isContinueDisabled &&
    handleContinue();

  const setEmailStorage = (email: string) => {
    const loweredEmail = email.toLowerCase();
    localStorage.setItem('email', loweredEmail);
    sessionStorage.setItem('email', loweredEmail);
  };

  const goToLogin = (email: string) => {
    setEmailStorage(email);
    // navigate('/login');
    setShowPasswordSection(true);
    setIsContinueDisabled(true);
  };

  // Use random pw to detect if user had registered and redirect to corresponding page
  // If registered, redirect to login page
  // If not, redirect to registration process
  const handleContinue = async () => {
    const email = emailRef.current!.value.toLowerCase();

    if (!email) {
      handlePopUp('error', 'Please enter your email');
      return;
    }

    try {
      await signInWithEmailAndPassword(app, email, pwTemp);
    } catch (err: any) {
      switch (err?.err?.name) {
        case 'UserNotFoundException':
          setEmailStorage(email);
          navigate('/terms');
          break;
        case 'NotAuthorizedException':
          goToLogin(email);
          break;
        default:
          console.log(err);
          console.log(err);
      }
    }
  };

  const handleEmailClick = () => {
    if (showPasswordSection) {
      setIsContinueDisabled(false);
    }
  };
  const handleBackToEmail = () => {
    setIsContinueDisabled(false);
  };

  return (
    <>
      <Navbar signUp landing isLogoDisplay={false} />
      <PopUp
        isOpen={popUp}
        onClose={closePopUp}
        status={status}
        message={message}
      />
      {/* <Box sx={userScrollLimit}> */}
      <Grid container sx={{height: '100%'}}>
        <Grid
          item
          xs={showPasswordSection ? 0 : 12}
          md={5.9}
          sx={{
            display: showPasswordSection ? {xs: 'none', md: 'block'} : 'block',
          }}
        >
          <Grow in unmountOnExit>
            <Box
              sx={{
                height: '100%',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <Box sx={contentContainer}>
                <Box sx={createAccContainer}>
                  <Box sx={accTextBox}>Create Account / Sign In</Box>
                </Box>
                <Box sx={descContainer}>
                  <Box sx={primaryTitleBox}>Ready to take the next step?</Box>
                  <Box sx={secondTitleBox}>Create an account or sign in</Box>
                </Box>
                {/* <Box sx={iframeBox}> */}

                <Box
                  component="img"
                  src={digiStaffLogo}
                  sx={{
                    height: 'auto',
                    width: '100%',
                    objectFit: 'contain',
                    mb: 2,
                    display: {xs: 'block', md: 'none'},
                  }}
                />
                {/* </Box> */}
                <Box sx={authContainer}>
                  <Box sx={emailSignUp}>
                    <Box sx={emailAddrBox}>
                      Email Address*
                      {formError.email && (
                        <Box sx={emailError}>{formError.email}</Box>
                      )}
                    </Box>
                    <Box sx={{width: '100%', pb: 1}}>
                      <TextField
                        type="email"
                        sx={textFieldSignIn}
                        inputRef={emailRef}
                        onChange={e => validateField(e)}
                        onKeyDown={handleKeyDown}
                        onClick={handleEmailClick}
                        name="email"
                      />
                    </Box>
                    {/* <Box sx={{height: {xs: '0.5rem', sm: '1rem', mt: 1}}} /> */}
                    <Button
                      id="anchorBtn"
                      variant="outlined"
                      sx={{...continueBtn, mt: 3}}
                      onPointerUp={handleContinue}
                      disabled={formError.email !== '' || isContinueDisabled}
                      name="login"
                    >
                      Continue →
                    </Button>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Grow>
        </Grid>
        <Grid
          item
          xs={0}
          sm={0}
          md={0.2}
          sx={{
            display: {xs: 'none', md: 'flex'},
            justifyContent: 'center',
            alignItems: 'center',
            pt: 9,
          }}
        >
          <Divider
            orientation="vertical"
            flexItem
            variant="middle"
            sx={{my: 4}}
          />
        </Grid>
        {showPasswordSection && (
          <Grid
            md={5.9}
            xs={showPasswordSection ? 12 : 0}
            sx={{
              display: showPasswordSection
                ? 'block'
                : {xs: 'none', md: 'block'},
            }}
          >
            <PasswordSection
              setShowPasswordSection={setShowPasswordSection}
              onBackToEmail={handleBackToEmail}
            />
          </Grid>
        )}
      </Grid>
    </>
  );
};
